var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apck-table',{ref:"table",style:({ opacity: _vm.disabled ? '25%' : null }),attrs:{"columns":_vm.cols,"actions":_vm.disabled || _vm.readonly ? undefined : _vm.actions,"src":_vm.srcUrl,"limit":50,"border":false,"show-toolbar":false,"show-page-bar":_vm.showPageBar,"new-style-table":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }